import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import NiceSelect from '../Header/NiceSelect';

function ContactOne() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    website: ''
  });
  const [status, setStatus] = useState('');

  const formHovered = useRef(false);
  const messageStart = useRef(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: check hover & min time
    if (!formHovered.current) {
      alert('Please interact with the form before submitting.');
      return;
    }
    const elapsed = messageStart.current ? Date.now() - messageStart.current : 0;
    if (elapsed < 4000) {
      alert('Please spend at least 4 seconds writing your message.');
      return;
    }

    setStatus('Sending...');

    try {
      const formBody = new URLSearchParams(formData).toString();
      const res = await fetch('reservation.php', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formBody
      });

      const data = await res.json();
      if (data.success) {
        setStatus('✅ ' + data.message);
        setFormData({ name: '', email: '', phone: '', message: '', website: '' });
      } else {
        setStatus('❌ ' + data.message);
      }
    } catch (err) {
      console.error(err);
      setStatus('❌ Error sending message.');
    }
  };

  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner" style={{ position: 'relative' }}>
        <div
          className="image-layer"
          style={{ backgroundImage: 'url(assets/images/coimbatore-homemade-food-banner.jpg)' }}
        ></div>
        <div className="auto-container">
          <div className="inner">
            <h1>Contact Us</h1>
            <div className="sub_text">
              <p>
                Home - <a href="contact" className="primary-color">Contact us</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>Tickling Tummy</span></div>
            <h2>Say Hello to – <span className="theme_color">Tickling Tummy</span></h2>
          </div>
          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                Whether you're hungry, curious, or just need to talk about rasam ratios—we’re here. We don’t
                have a call center. No bots. Just real people in our kitchen checking their phones in
                between stirring pots and packing meals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Page Section */}
      <section className="contact-page section-kt">
        <div className="auto-container">
          <div className="c-page-form-box">
            <div className="row clearfix">

              {/* Form Image Section */}
              <div className="loc-block info-block col-lg-5 col-md-12 col-sm-12">
                <div className="contact-image">
                  <img src="assets/images/contact-us-banner.jpg" alt="budget lunch delivery Coimbatore" />
                </div>
                <h5>Our Kitchen</h5>
                <div className="text">
                  R.S. Puram, Coimbatore, Tamil Nadu – 641002 <br /><br />
                  <span className="c-info-ttl">Mon–Sat</span> - 8:00 AM – 7:30 PM <br /><br />
                  <span className="more-link">
                    Call or WhatsApp : <a href="tel:+919385000111">+91 93850 00111</a>
                  </span>
                </div>
              </div>

              {/* Vertical Line */}
              <div className="col-12 col-md-1 d-flex justify-content-center middle-line-wrapper">
                <div className="middle-line-container">
                  <div className="dot top-dot"></div>
                  <div className="v-line"></div>
                  <div className="dot bottom-dot"></div>
                </div>
              </div>

              {/* Form Section */}
              <div className="loc-block col-lg-6 col-md-12 col-sm-12">
                <div className="form-side">
                  <div className="title-box centered">
                    <div className="subtitle"><span>Write to us</span></div>
                    <h2>Message us</h2>
                    <div className="text desc">
                      Contact us - we aim to reply within 24 hours and are happy to help!
                    </div>
                  </div>

                  <div className="default-form reservation-form">
                    <form
                      onSubmit={handleSubmit}
                      onMouseEnter={() => (formHovered.current = true)}
                    >
                      <div className="clearfix">
                        <input
                          type="text"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          autoComplete="off"
                          tabIndex="-1"
                          aria-hidden="true"
                          style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                        />
                        <div className="form-group">
                          <div className="field-inner">
                            <input
                              type="text"
                              name="name"
                              placeholder="Your Name"
                              required
                              value={formData.name}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="field-inner">
                            <input
                              type="text"
                              name="email"
                              placeholder="Your Email"
                              required
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="field-inner">
                            <input
                              type="text"
                              name="phone"
                              placeholder="Phone Number"
                              required
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="field-inner">
                            <textarea
                              name="message"
                              placeholder="Special Request"
                              required
                              value={formData.message}
                              onChange={(e) => {
                                handleChange(e);
                                if (!messageStart.current) messageStart.current = Date.now();
                              }}
                            ></textarea>
                          </div>
                        </div>

                        <div className="form-group">
                          <button type="submit" className="theme-btn btn-style-one clearfix">
                            <span className="btn-wrap">
                              <span className="text-one">send your message</span>
                              <span className="text-two">send your message</span>
                            </span>
                          </button>
                        </div>
                      </div>

                      {status && <p style={{ marginTop: '10px' }}>{status}</p>}
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactOne;
